---
description: Turn an agreed direction into a short step-by-step implementation plan.
---

1. Re-read the relevant files with read and grep so each step names real paths.
2. Write the plan as numbered steps: each step states the tool (write, edit, execute, measure, check, docs), the file, and the expected outcome.
3. Keep the plan small: prefer fewer than seven steps, each independently verifiable.
4. State how to verify: build report after write or edit, measure for sizes, check for watertight and manifold.
5. Note open questions for question instead of baking in guesses.
6. Stop at the plan. Do not implement it.
